import React from "react";
import { Col, Row } from "react-bootstrap";
import AnimatedSelect from "../../../shared/AnimatedSelect";
import "../../../shared/AnimatedSelect.css";

const GeographyFilters = ({ filterValues = {}, region, state, city, onFilterChange }) => {
  return (
      <>
        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.hasDone || ""}
            options={[
              { label: "Select Contains", value: "" },
              { label: "Contains", value: "Contains" },
              { label: "Does Not Contain", value: "Does Not Contain" }
            ]}
            onChange={(value) => onFilterChange && onFilterChange("hasDone", value)}
          />
        </Col>
        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.zone || ""}
            options={[
              { label: "Select Zone", value: "" },
              ...region.map((item) => ({
                label: item.name,
                value: item.id
              }))
            ]}
            onChange={(value) => onFilterChange && onFilterChange("zone", value)}
          />
        </Col>

        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.state || ""}
            options={[
              { label: "Select State", value: "" },
              ...state.map((item) => ({
                label: item.name,
                value: item.id
              }))
            ]}
            onChange={(value) => onFilterChange && onFilterChange("state", value)}
          />
        </Col>

        <Col className="custom_col">
          <AnimatedSelect
            multiple
            value={Array.isArray(filterValues.city) ? filterValues.city : (filterValues.city ? [filterValues.city] : [])}
            options={[
              ...city.map((item) => ({
                label: item.name,
                value: item.id
              }))
            ]}
            placeholder="Select Cities"
            onChange={(value) => onFilterChange && onFilterChange("city", value)}
          />
        </Col>        
      </>
    
  );
};

export default GeographyFilters;
